import { RenewalsModuleActions, RenewalsModuleActionTypes } from '../actions/renewals-module.actions';
import { renewalsModuleInitialState, RenewalsModuleState } from '../renewals-module.state';

export function renewalsModuleReducer(state = renewalsModuleInitialState, action: RenewalsModuleActions): RenewalsModuleState {
  switch (action.type) {
    case RenewalsModuleActionTypes.SetOriginalQuoteRequestId:
      return { ...state, originalQuoteRequestId: action.originalQuoteRequestId };
    default:
      return state;
  }
}
